export const tratamiento = {
  idtratamiento: null,
  slug: '',
  nombre: '',
  descripcion: '',
  nombre_imagen: '',
  imagen: '',
  icon_after_nombre: '',
  // nombre_cms: '',
  // contenido: '',
  estado: 1,
}
